import React, { PropsWithChildren, useCallback } from "react";
import { observer } from "mobx-react-lite";

import "./Collapsible.scss";
import { BreadcrumbArrow } from "../svg/svgImageList";
import useTheme from "../../services/theme-service/ThemeService";
import { SectionDivider } from "../data-components/sections/DataSections";
import Button from "../button/Button";
import { CollapsibleService } from "../../services/collapsible/CollapsibleService";

interface CollapsibleProps {
  titleKey: string;
  collapsibleService: CollapsibleService;
  withoutSectionDivider?: boolean;
  id?: string;
}

function Collapsible({
  titleKey,
  children,
  collapsibleService,
  withoutSectionDivider,
  id,
}: PropsWithChildren<CollapsibleProps>) {
  const { themeClass } = useTheme();

  const toggle = useCallback(() => {
    collapsibleService.toggle();
  }, [collapsibleService]);

  return (
    <>
      <div className="collapsible" id={id}>
        <Button
          className="collapsible-header"
          textKey={titleKey}
          onClick={toggle}
          icon={{
            svg: BreadcrumbArrow,
            className: themeClass(
              ["icon"],
              ["collapsible-icon", collapsibleService.isCollapsed ? "closed" : "open"]
            ),
          }}
        />
        <div className={`collapsible-content ${collapsibleService.isCollapsed ? "hide" : ""}`}>
          {!collapsibleService.isCollapsed && children}
        </div>
      </div>
      {(!withoutSectionDivider || collapsibleService.isCollapsed) && <SectionDivider />}
    </>
  );
}

export default observer(Collapsible);
